import { Card } from '@ipfabric/ui-components/Card/Card';
import { PageHeader } from '@ipfabric/ui-components/PageHeader/PageHeader';
import { RocketAnimation } from './RocketAnimation/RocketAnimation';
import './styles/rocket.css';
import { useGetSettings } from '@ipfabric/api-client/client/model/settings/settings';
import React from 'react';
import { renderQuery } from 'utils/react-query/renderQuery';
import { pickDiscoverySettingsFromGlobalSettings } from '../../utils/pickDiscoverySettingsFromGlobalSettings';
import { WizardNavigationButtons } from './WizardNavigationButtons';
import { WizardPageLoading } from './WizardPageLoading';
import type { WizardPageProps } from './configWizard.types';
import type { rocketStart } from './rocketStart';

export const DiscoveryConfigWizardPage4 = (props: WizardPageProps) => {
  const globalSettingsQuery = useGetSettings();
  const rocketRef = React.useRef<
    HTMLDivElement & ReturnType<typeof rocketStart>
  >(null);

  const wizardContainerRef = React.useRef<HTMLDivElement>(null);
  const [disableButtons, setDisableButtons] = React.useState(false);

  return renderQuery({
    query: globalSettingsQuery,
    renderStaleDataOnMount: false,
    pending: () => <WizardPageLoading wizardStepper={props.wizardStepper} />,
    success: (data) => (
      <>
        <PageHeader
          elevated
          width='content-default'
          label='Configuration Wizard'
          additionalControls={props.wizardStepper(disableButtons)}
        />
        <div className='flex flex-col items-center'>
          <div
            className='w-full max-w-content-default flex flex-col px mt mb gap'
            ref={wizardContainerRef}
            id='wizard'
          >
            <div className='text-2xl font-semibold text-default'>
              Configuration complete
            </div>
            <Card className='flex flex-col min-h-[424px] overflow-hidden'>
              <RocketAnimation ref={rocketRef} />
              <WizardNavigationButtons
                onPrevious={() => {
                  props.onPreviousStep();
                }}
                onNext={async () => {
                  rocketRef.current?.fly();
                  setDisableButtons(true);
                  try {
                    await props.onFinalSubmit(
                      pickDiscoverySettingsFromGlobalSettings(data),
                    );
                  } finally {
                    setDisableButtons(false);
                  }
                }}
                isLoading={disableButtons}
                nextText='Run discovery'
              />
            </Card>
          </div>
        </div>
      </>
    ),
  });
};
